module.exports = __webpack_public_path__ + "static/media/new-tab-white.793dee0b.svg";